import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  BooleanParam,
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";

import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import CountUp from "react-countup";
import { getUserRecruiterVirtual } from "store/user/thunk";
import UserApi from "api/userApi";
import CollapseFilter from "components/Common/CollapseFilter";
import DatePickerCustom from "components/Common/DatePickerCustom";
import DropdownPlatform from "components/Common/DropdownPlatform";
import ModalPreview from "components/Common/ModalPreview";
import {
  COLOR_ADULT_VERIFY,
  COLOR_JOB_POSTING_STATUS,
  COLOR_SOURCE_CHANNEL,
  COLOR_STATUS_ACTIVE_DISABLE,
  COLOR_STORE_CONNECTION,
  COLOR_USER_TYPE,
  ENUM_ADULT_VERIFY,
  ENUM_SOURCE_CHANNEL,
  LIST_CHANNEL_USER_OPTION,
  LIST_OPTION_ADULT_VERIFY,
  LIST_OPTION_JOB_POSTING_STATUS,
  LIST_OPTION_OS,
  LIST_OPTION_PLATFORM,
  LIST_OPTION_SOURCE_CHANNEL,
  LIST_OPTION_STORE_CONNECTION,
  LIST_OPTION_USER_TYPE,
  STATUS_ACTIVE_DISABLE_OPTION,
} from "helpers/constans";
import {
  formatDateStringToKorea,
  formatDateStringToUTC,
  getKeyDeviceModelByValue,
  getPlatFormImage,
} from "helpers/format";
import { capitalizeFirstLetter } from "utils";
import noImageJob from "../../../assets/images/no-job-post.png";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import DropdownOptionImage from "components/Common/DropdownOptionImage";
import CopyWrapper from "components/Common/CopyWrapper";
import IPHONE_MODELS from "helpers/iphone_models";
import CheckboxStatusUser from "components/Common/CheckboxStatusUser";
import userApi from "api/userApi";
import TooltipCustom from "components/Common/TooltipCustom";
import { Link } from "react-router-dom";
import DropdownChannel from "components/Common/DropdownChannel";
import RecruiterDetail from "../RecruiterList/RecruiterDetail";
import VerifiedAdultInfo from "components/Common/VerifiedAdultInfo";
import Permission from "components/Common/Permission";
import ModalPerNotification from "components/Common/ModalPerNotification";
import { getPhoneFormat } from "components/Common/PhoneInput";
import { PatternFormat } from "react-number-format";

interface Option {
  label: string;
  value: string;
}

registerLocale("en", en);
registerLocale("ko", ko);

const RecruiterVirtualList = () => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    type: withDefault(StringParam, "MANAGER"),
    emailSns: withDefault(StringParam, ""),
    ip: withDefault(StringParam, ""),
    deviceModel: withDefault(StringParam, ""),
    deviceManufacturer: withDefault(StringParam, ""),
    deviceUdid: withDefault(StringParam, ""),
    userProvider: withDefault(StringParam, ""),
    deviceOs: withDefault(StringParam, ""),
    appVersion: withDefault(StringParam, ""),
    storeName: withDefault(StringParam, ""),
    storeAddress: withDefault(StringParam, ""),
    contactName: withDefault(StringParam, ""),
    contactPhone: withDefault(StringParam, ""),
    isAgeVerified: withDefault(StringParam, ""),
    storeConnected: withDefault(StringParam, ""),
    jobPosted: withDefault(StringParam, ""),
    isActive: withDefault(StringParam, ""),
    agency: withDefault(StringParam, ""),
    channel: withDefault(StringParam, ""),
    sourceChannel: withDefault(StringParam, ""),
    registeredFrom: withDefault(StringParam, ""),
    registeredTo: withDefault(StringParam, ""),
    isReal: withDefault(BooleanParam, false),
  });

  const [emailSearch, setEmailSearch] = useState<string>(query?.emailSns || "");
  const [ipAddressSearch, setIPAddressSearch] = useState<string>(
    query?.ip || ""
  );
  const [deviceModelSearch, setDeviceModelSearch] = useState<string>(
    query?.deviceModel || ""
  );
  const [deviceManufactureSearch, setDeviceManufactureSearch] =
    useState<string>(query?.deviceManufacturer || "");
  const [uuid2Search, setUUID2Search] = useState<string>(
    query?.deviceUdid || ""
  );
  const [appVersionSearch, setAppVersionSearch] = useState<string>(
    query?.appVersion || ""
  );
  const [storeNameSearch, setStoreNameSearch] = useState<string>(
    query?.storeName || ""
  );
  const [storeAddressSearch, setStoreAddressSearch] = useState<string>(
    query?.storeAddress || ""
  );
  const [contactNameSearch, setContactNameSearch] = useState<string>(
    query?.contactName || ""
  );
  const [contactPhoneSearch, setContactPhoneSearch] = useState<string>(
    query?.contactPhone || ""
  );
  const [summary, setSummary] = useState<any>(null);
  const [agencySearch, setAgencySearch] = useState<string>(query?.agency || "");

  const [platFormSearch, setPlatFormSearch] = useState<Option | null>(
    LIST_OPTION_PLATFORM?.filter(
      (item) => String(item?.value) === String(query?.userProvider)
    )[0]
  );

  const [oSSearch, setOSSearch] = useState<any | null>(
    LIST_OPTION_OS?.filter(
      (item) => String(item?.value) === String(query?.deviceOs)
    )[0]?.value || ""
  );

  const [userTypeSearch, setUserTypeSearch] = useState<any>(
    LIST_OPTION_USER_TYPE?.find((item) => item?.value === query?.userLoginType)
      ?.value ?? ""
  );

  const [adultVerifySearch, setAdultVerifySearch] = useState<any>(
    LIST_OPTION_ADULT_VERIFY?.find(
      (item) => item?.value === query?.isAgeVerified
    )?.value ?? ""
  );

  const [storeConnectionSearch, setStoreConnectionSearch] = useState<any>(
    LIST_OPTION_STORE_CONNECTION?.find(
      (item) => item?.value === query?.storeConnected
    )?.value ?? ""
  );

  const [jobPostingStatusSearch, setJobPostingStatusSearch] = useState<any>(
    LIST_OPTION_JOB_POSTING_STATUS?.find(
      (item) => item?.value === query?.jobPosted
    )?.value ?? ""
  );

  const [statusSearch, setStatusSearch] = useState<any>(
    STATUS_ACTIVE_DISABLE_OPTION?.find(
      (item) => item?.value === parseInt(query?.isActive)
    )?.value ?? ""
  );

  const [channelSearch, setChannelSearch] = useState<Option | any>(
    LIST_CHANNEL_USER_OPTION?.find((item) => item?.value === query?.channel)
      ?.value || ""
  );


  const [sourceChannelSearch, setSourceChannelSearch] = useState<any>(
    LIST_OPTION_SOURCE_CHANNEL?.find(
      (item) => item?.value === (query?.sourceChannel)
    )?.value ?? ""
  );


  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.registeredFrom
      ? moment(query?.registeredFrom || "", "Y-MM-DD").toDate()
      : null,
    query?.registeredTo
      ? moment(query?.registeredTo || "", "Y-MM-DD").toDate()
      : null,
  ]);
  const [registeredFrom, registeredTo] = dateSearch;

  const [itemToEdit, setItemToEdit] = useState<any>(null);
  const [itemToDelete, setItemToDelete] = useState<any>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [linkImage, setLinkImage] = useState<any>(null);

  const selectLayoutState = (state: any) => state.UserRecruiterVirtual;

  const UserProperties = createSelector(selectLayoutState, (state) => ({
    users: state.users,
    isUserLoading: state.isUserLoading,
    isUserSuccess: state.isUserSuccess,

    error: state.error,
  }));

  // Inside your component
  const { users, isUserLoading } = useSelector(UserProperties);

  function loadTableData() {
    dispatch(getUserRecruiterVirtual(query));
  }

  const initSummary = async () => {
    try {
      const res = await userApi.getSummary(query);
      setSummary(res?.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    loadTableData();
    initSummary();
  }, [dispatch, JSON.stringify(query)]);

  const searchData = () => {
    const nameDeviceModelSearch = getKeyDeviceModelByValue(
      deviceModelSearch.trim()
    );

    setQuery({
      ...query,
      emailSns: emailSearch.trim() || "",
      ip: ipAddressSearch.trim() || "",
      deviceModel: nameDeviceModelSearch || "",
      deviceManufacturer: deviceManufactureSearch.trim() || "",
      deviceUdid: uuid2Search.trim() || "",
      userProvider: platFormSearch?.value || "",
      deviceOs: oSSearch || "",
      appVersion: appVersionSearch || "",
      storeName: storeNameSearch || "",
      storeAddress: storeAddressSearch || "",
      contactName: contactNameSearch.trim() || "",
      contactPhone: contactPhoneSearch.trim() || "",
      userLoginType: userTypeSearch,
      isAgeVerified: adultVerifySearch,
      storeConnected: storeConnectionSearch,
      jobPosted: jobPostingStatusSearch,
      agency: agencySearch.trim() || "",
      channel: channelSearch || "",
      sourceChannel: sourceChannelSearch || "",
      isActive: statusSearch,
      registeredFrom: registeredFrom
        ? formatDateStringToUTC(
          moment(new Date(registeredFrom))
            .startOf("day")
            .format("Y-MM-DD HH:mm:ss")
        )
        : "",
      registeredTo: registeredTo
        ? formatDateStringToUTC(
          moment(new Date(registeredTo))
            .endOf("day")
            .format("Y-MM-DD HH:mm:ss")
        )
        : "",
      //sortBy: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        emailSns: "",
        ip: "",
        deviceModel: "",
        deviceManufacturer: "",
        deviceUdid: "",
        userProvider: "",
        deviceOs: "",
        appVersion: "",
        storeName: "",
        storeAddress: "",
        contactName: "",
        contactPhone: "",
        userLoginType: "",
        isAgeVerified: "",
        storeConnected: "",
        jobPosted: "",
        agency: "",
        channel: "",
        sourceChannel: "",
        isActive: null,
        registeredFrom: "",
        registeredTo: "",
        sortBy: "",
        time_request: +new Date(),
        page: 1,
      },
      "push"
    );
    setEmailSearch("");
    setIPAddressSearch((_prev) => "");
    setDeviceModelSearch((_prev) => "");
    setDeviceManufactureSearch((_prev) => "");
    setUUID2Search((_prev) => "");
    setPlatFormSearch((_prev) => null);
    setOSSearch("");
    setUserTypeSearch("");
    setAppVersionSearch("");
    setStoreNameSearch("");
    setStoreAddressSearch("");
    setContactNameSearch("");
    setContactPhoneSearch("");
    setAdultVerifySearch("");
    setStoreConnectionSearch("");
    setJobPostingStatusSearch("");
    setAgencySearch("");
    setChannelSearch("");
    setSourceChannelSearch("");
    setStatusSearch("");
    setStoreNameSearch("");
    setDateSearch([null, null]);
  };

  // Begin::Update User
  const onCloseClick = () => {
    setItemToEdit((_prev: any) => null);
  };

  const triggerRefresh = () => {
    // onCloseClick();
    loadTableData();
  };
  //End::Update User

  const [itemConfirmAdultVerify, setItemConfirmAdultVerify] = useState<any>(null);
  const [isConfirmAdultVerifyLoading, setIsConfirmAdultVerifyLoading] = useState<boolean>(false);
  const handleUpdateAdultVerify = async (item: any) => {
    if (!item) return;
    const userId = item?.id;
    const status = item?.isAgeVerified ? 1 : 0;

    setIsConfirmAdultVerifyLoading(true);
    try {
      let params = {
        action: "reset",
      };

      if (status === ENUM_ADULT_VERIFY.NOT_VERIFIED) {
        params = {
          action: "verify",
        };
      }
      const resVerify: any = await userApi.putVerifyStatusUser(userId, params);
      if (resVerify?.code === 200) {
        triggerRefresh && triggerRefresh();

        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${resVerify?.message}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    } finally {
      setItemConfirmAdultVerify(null);
      setIsConfirmAdultVerifyLoading(false);
    }
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 60,
        thClass: "whitespace-nowrap",
        Cell: ({ ...props }) => {
          return (
            <div style={{ width: 35 }}>
              {users?.pagination?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Status"),
        accessor: "isActive",
        thWidth: 80,
        filterable: false,
        sortable: false,
        thClass: "text-center",
        Cell: (cell: any) => {
          const item = cell?.row?.original;

          return (
            <CheckboxStatusUser item={item} triggerRefresh={triggerRefresh} />
          );
        },
      },
      {
        Header: t("User Type"),
        accessor: "userDevice.loginType",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const status = cell?.value === "GUEST" ? "GUEST" : "NORMAL";
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_USER_TYPE[status] || "secondary"
                  }`}
              >
                {t(
                  LIST_OPTION_USER_TYPE?.find(
                    (item: any) => String(item?.value) === String(status)
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Source Channel"),
        accessor: "sourceChannel",
        thWidth: 140,
        thClass: "text-center  whitespace-nowrap",
        Cell: (cell: any) => {
          const sourceChannel = cell?.value;

          return sourceChannel ? (
            <div className="text-center" style={{ minWidth: 80 }}>
              <div
                className={`align-items-center gap-1 bg-primary badge rounded-pill bg-${COLOR_SOURCE_CHANNEL[sourceChannel] || "secondary"}`}
              >
                {t(
                  LIST_OPTION_SOURCE_CHANNEL?.find(
                    (item: any) => String(item?.value) === String(sourceChannel)
                  )?.label || ""
                )}
              </div>
            </div>
          ) : <div className="text-center">-</div>;
        },
      },
      // {
      //   Header: t("Photo"),
      //   accessor: "profile.imageUrls",
      //   thClass: "text-center whitespace-nowrap",
      //   filterable: true,
      //   sortable: false,
      //   thWidth: 80,
      //   Cell: (cell: any) => (
      //     <>
      //       <div className="w-100 text-center " style={{ minWidth: "60px" }}>
      //         <div
      //           style={{ width: "45px" }}
      //           className="m-auto cursor-pointer"
      //           onClick={() => setLinkImage({ url: cell?.value ?? "" })}
      //         >
      //           <img
      //             src={cell?.value ?? avatar1}
      //             className="rounded-circle avatar-sm"
      //             alt="thumbnail"
      //             onError={({ currentTarget }) => {
      //               currentTarget.onerror = null; // prevents looping
      //               currentTarget.src = avatar1;
      //             }}
      //           />
      //         </div>
      //       </div>
      //     </>
      //   ),
      // },
      {
        Header: t("Store Thumbnail"),
        accessor: "store.thumbnailUrl",
        thClass: "text-center whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 150,
        Cell: (cell: any) => (
          <>
            <div className="w-100 text-center " style={{ minWidth: "80px" }}>
              <div
                style={{ width: "80px" }}
                className="m-auto cursor-pointer"
                onClick={() => setLinkImage({ url: cell?.value ?? "" })}
              >
                <img
                  src={cell?.value ?? noImageJob}
                  width={80}
                  height={80}
                  className=""
                  alt="thumbnail"
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = noImageJob;
                  }}
                />
              </div>
            </div>
          </>
        ),
      },
      {
        Header: t("Email SNS"),
        accessor: "email",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 220,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const providerID = item?.providerId;
          const email = cell?.value ? cell?.value : providerID;

          return email ? (
            <div 
              className="cursor-pointer text-primary"
              onClick={() => {
                setItemToEdit(item);
              }}
              >
              <CopyWrapper contentCopy={email}>{`${email}`}</CopyWrapper>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("Contact Name"),
        accessor: "store.managerName",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 200,
        Cell: (cell: any) => {
          const contactName = cell?.value;

          return contactName ? (
            <div className="cursor-pointer">
              <CopyWrapper contentCopy={contactName}>
                {`${contactName}`}
              </CopyWrapper>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("Contact Phone Number"),
        accessor: "store.managerPhoneNumber",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 250,
        Cell: (cell: any) => {
          let { format } = getPhoneFormat(cell?.value);
          const showFormat = format !== "####-####" ? format : "#####################";

          return cell?.value ? (
            <div className="cursor-pointer d-flex flex-column">
              <CopyWrapper contentCopy={cell?.value}>
                <PatternFormat
                  value={cell?.value}
                  displayType="text"
                  format={showFormat}
                />
              </CopyWrapper>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("Adult Verify"),
        accessor: "isAgeVerified",
        filterable: false,
        sortable: false,
        thWidth: 160,
        thClass: "",
        Cell: (cell: any) => {
          const status = cell?.value ? 1 : 0;
          let item = cell?.row?.original;

          return (
            <div className="" style={{ minWidth: 80 }}>
              <div>
                <span
                  className={`rounded-pill badge bg-${COLOR_ADULT_VERIFY[status] || "secondary"
                    }`}
                >
                  {t(
                    LIST_OPTION_ADULT_VERIFY?.find(
                      (item: any) => String(item?.value) === String(status)
                    )?.label || ""
                  )}
                </span>

                <small
                  className={`text-info cursor-pointer text-decoration-underline fw-medium ${status === ENUM_ADULT_VERIFY.NOT_VERIFIED
                    ? "d-block"
                    : "mx-2"
                    }`}
                  onClick={() => {
                    setItemConfirmAdultVerify(item);
                  }}
                >
                  {status === ENUM_ADULT_VERIFY.NOT_VERIFIED
                    ? t("Verify Now")
                    : t("Reset")}
                </small>
              </div>

              {status === ENUM_ADULT_VERIFY.VERIFIED && (
                <small className="text-primary" style={{ fontSize: "10px" }}>
                  {formatDateStringToKorea(
                    item?.ageVerifiedAt,
                    "YYYY-MM-DD HH:mm"
                  )}
                </small>
              )}
            </div>
          );
        },
      },
      {
        Header: t("Verified Adult Info"),
        accessor: "verifiedInfoLog",
        filterable: false,
        sortable: false,
        thWidth: 230,
        Cell: (cell: any) => {
          let isAgeVerified = cell?.row?.original?.isAgeVerified;
          let verifiedInfoLog = cell?.value;

          return (
            (isAgeVerified) ? (
              <VerifiedAdultInfo verifiedInfoLog={verifiedInfoLog} />
            ) : (
              <>-</>
            )
          );
        },
      },
      {
        Header: t("Agency"),
        accessor: "agency",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "whitespace-nowrap text-center",
        Cell: (cell: any) => {
          let agencies = cell?.row?.original?.agencies?.[0];
          const agencyCode = agencies?.agencyId || "";
          const agencyName = agencies?.agencyName || "";

          return agencyName && agencyCode ? (
            <div className="text-center">
              <div>{agencyName}</div>
              <div className="text-primary">{agencyCode}</div>
            </div>
          ) : (
            <div className="text-center">-</div>
          );
        },
      },
      {
        Header: t("Channel"),
        accessor: "channel",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          let agencies = cell?.row?.original?.agencies;
          const channel = agencies?.[0]?.channel || "";
          const imgChannel = getPlatFormImage(channel);

          return (
            <div
              className="d-flex flex-column gap-1"
              style={{ minWidth: "100px" }}
            >
              <div className="cursor-pointer d-flex gap-2 align-items-center whitespace-nowrap">
                {imgChannel && (
                  <div style={{ width: "25px" }}>
                    <img
                      src={imgChannel}
                      width={25}
                      height={25}
                      alt="channel"
                    />
                  </div>
                )}

                <div className="cursor-pointer">
                  {t(
                    LIST_CHANNEL_USER_OPTION?.find(
                      (item: any) => String(item?.value) === String(channel)
                    )?.label ||
                    channel ||
                    "-"
                  )}
                </div>
              </div>
            </div>
          );
        },
      },
      {
        Header: t("Platform"),
        accessor: "platform",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 140,
        Cell: (cell: any) => {
          let user_provider = cell?.row?.original?.provider;
          let lowText = user_provider ? user_provider.toLowerCase() : "";
          let imgPlatform = getPlatFormImage(user_provider);

          return user_provider ? (
            <div className="d-flex flex-column gap-1">
              <div className="cursor-pointer d-flex gap-2 align-items-center whitespace-nowrap">
                <div style={{ width: "25px" }}>
                  {imgPlatform && (
                    <img
                      src={imgPlatform}
                      width={25}
                      height={25}
                      alt="user_provider"
                    />
                  )}
                </div>
                <div className="cursor-pointer">
                  {t(
                    capitalizeFirstLetter(
                      lowText === "default" || lowText == "guest"
                        ? "Email"
                        : lowText
                    )
                  )}
                </div>
              </div>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("OS"),
        accessor: "userDevice.device.os",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 140,
        Cell: (cell: any) => {
          const deviceOS = cell?.value;
          let imgOS = getPlatFormImage(deviceOS);

          return deviceOS ? (
            <div
              className="d-flex align-items-center"
              style={{ minWidth: "110px" }}
            >
              {imgOS ? (
                <div style={{ width: "25px" }} className="me-1">
                  {imgOS ? (
                    <img src={imgOS} width={20} height={20} alt="platform" />
                  ) : (
                    <span
                      className={`bg-secondary`}
                      style={{
                        width: "20px",
                        height: "20px",
                        borderRadius: "3px",
                      }}
                    ></span>
                  )}
                </div>
              ) : (
                ""
              )}
              <div>
                {t(
                  LIST_OPTION_OS?.find((item) => item?.value === deviceOS)
                    ?.label ?? ""
                )}
              </div>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("IP"),
        accessor: "userDevice.ipAddress",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 140,
        Cell: (cell: any) => {
          const ip = cell?.value;
          return ip ? (
            <div className="cursor-pointer">
              <CopyWrapper contentCopy={ip}>{`${ip}`}</CopyWrapper>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("Device Model"),
        accessor: "userDevice.device.model",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 160,
        Cell: (cell: any) => {
          const item = cell?.row?.original?.userDevice?.device;
          let deviceModel = item?.model;
          const os = item?.os;
          if (os === "ios") {
            deviceModel = deviceModel
              ? IPHONE_MODELS[deviceModel as keyof typeof IPHONE_MODELS] ??
              deviceModel
              : "";
          }

          return deviceModel ? (
            <CopyWrapper
              contentCopy={t(`${deviceModel}`)}
              style={{ width: 150 }}
            >
              {t(`${deviceModel}`)}
            </CopyWrapper>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("Device Manufacturer"),
        accessor: "userDevice.device.manufacturer",
        filterable: true,
        sortable: false,
        thWidth: 170,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const manufacturer = cell?.value;
          return manufacturer ? (
            <div className="cursor-pointer" style={{ minWidth: "160px" }}>
              <CopyWrapper contentCopy={manufacturer}>
                {`${manufacturer}`}
              </CopyWrapper>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("UUID"),
        accessor: "userDevice.device.udid",
        filterable: true,
        sortable: false,
        thWidth: 220,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const udid = cell?.value;
          return udid ? (
            <div className="cursor-pointer" style={{ minWidth: "200px" }}>
              <CopyWrapper contentCopy={udid}>{`${udid}`}</CopyWrapper>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("App Version"),
        accessor: "userDevice",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 120,
        Cell: (cell: any) => {
          const row = cell?.value;
          const appVersion = row?.appBuild
            ? `${row?.appVersion} (${row?.appBuild})`
            : row?.appVersion;
          return appVersion ? (
            <div className="cursor-pointer" style={{ minWidth: "110px" }}>
              <CopyWrapper contentCopy={appVersion}>
                {`${appVersion}`}
              </CopyWrapper>
            </div>
          ) : (
            "-"
          );
        },
      },

      {
        Header: t("Store Name"),
        accessor: "store.name",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 160,
        Cell: (cell: any) => {
          const ip = cell?.value;
          return ip ? (
            <div className="cursor-pointer">
              <CopyWrapper contentCopy={ip}>{`${ip}`}</CopyWrapper>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("Store Address"),
        accessor: "store.address.shortAddress",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 200,
        Cell: (cell: any) => {
          const address = cell?.value;
          return address ? (
            <div className="cursor-pointer">
              <CopyWrapper contentCopy={address}>{`${address}`}</CopyWrapper>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("Job Posts Count"),
        accessor: "countJobPost",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 140,
        Cell: (cell: any) => {
          const countJobPost = cell?.value;
          return (
            <div
              className={`cursor-pointer text-end  ${countJobPost && "text-primary"
                }`}
            >
              {`${countJobPost || "-"}`}
            </div>
          );
        },
      },
      {
        Header: `${t("Permission")}`,
        accessor: "permission",
        filterable: false,
        sortable: false,
        thWidth: i18n?.language === "en" ? 370 : 310,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;

          return (
            <Permission permission={item?.userDevice?.grantedPermissions} userID={item?.id} handleShowNotification={handleShowNotification} />
          );
        },
      },
      {
        Header: t("Created at"),
        accessor: "createdAt",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || "-"}</span>{" "}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Signup Date"),
        accessor: "registeredAt",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || "-"}</span>{" "}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("App Install Date"),
        accessor: "userDevice.device.installedAt",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || "-"}</span>{" "}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Action"),
        thClass: "text-center",
        thWidth: 100,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul className="list-inline flex-wrap justify-content-center hstack gap-2 mb-0">
              <TooltipCustom title={t("Detail User")} id={`detail-${item?.id}`}>
                <Link
                  className="btn btn-sm btn-soft-primary edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setItemToEdit(item);
                  }}
                >
                  <i className="ri-eye-fill align-bottom"></i>
                </Link>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, users?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  // Begin::Delete
  const handleActionDelete = async (id: any) => {
    if (!id) {
      return;
    }
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await UserApi?.deleteUser(id);

      if (response?.success) {
        loadTableData();
        setIsConfirmLoading((_prev) => false);
        setItemToDelete(false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };
  // End::Delete

  //Begin::Show Notification
  const [itemNotification, setItemNotification] = useState(null);
  const handleShowNotification = (userID: any) => {
    if (!userID) return;

    setItemNotification(userID)
  }

  const handleCloseNotification = () => {
    setItemNotification(null)
  }
  //End::Show Notification

  useEffect(() => {
    document.title = `${t("Recruiter (Virtual)")} | OnnyJob`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Recruiter (Virtual)")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <div className="d-block d-xl-flex justify-content-between align-items-start">
                    <div
                      className="d-flex w-100 flex-wrap gap-3 gap-md-2 menu-card-statistics justify-content-start mb-3 mb-xl-2 position-relative"
                      style={{ maxWidth: "100%" }}
                    >
                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={summary?.total || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Store Linked User")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={summary?.storeLinked || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Store Not Linked User")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={summary?.storeNotLinked || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Email SNS")}
                          isShow={!!emailSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Email SNS")}...`}
                            value={emailSearch}
                            onChange={(e) => setEmailSearch(e.target.value)}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Store Name")}`}
                          isShow={!!storeNameSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Store Name")}...`}
                            value={storeNameSearch}
                            onChange={(e) => setStoreNameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Store Address")}`}
                          isShow={!!storeAddressSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Store Address")}...`}
                            value={storeAddressSearch}
                            onChange={(e) =>
                              setStoreAddressSearch(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          isShow={!!contactNameSearch}
                          label={`${t("Contact Name")}`}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Contact Name")}...`}
                            value={contactNameSearch}
                            onChange={(e) =>
                              setContactNameSearch(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={`${t("Contact Phone Number")}`}
                          isShow={!!contactPhoneSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Contact Phone Number")}...`}
                            value={contactPhoneSearch}
                            onChange={(e) =>
                              setContactPhoneSearch(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={t("Ip Address")}
                          isShow={!!ipAddressSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Ip Address")}...`}
                            value={ipAddressSearch}
                            onChange={(e) => setIPAddressSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={`${t("Device Model")}`}
                          isShow={!!deviceModelSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Device Model")}...`}
                            value={deviceModelSearch}
                            onChange={(e) =>
                              setDeviceModelSearch(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={`${t("Device Manufacturer")}`}
                          isShow={!!deviceManufactureSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Device Manufacturer")}...`}
                            value={deviceManufactureSearch}
                            onChange={(e) =>
                              setDeviceManufactureSearch(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={`${t("UUID")}`}
                          isShow={!!uuid2Search}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("UUID")}...`}
                            value={uuid2Search}
                            onChange={(e) => setUUID2Search(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={`${t("App Version")}`}
                          isShow={!!appVersionSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("App Version")}...`}
                            value={appVersionSearch}
                            onChange={(e) =>
                              setAppVersionSearch(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Platform")} isShow={true}>
                          <DropdownPlatform
                            name="platform"
                            placeholder={`${t("Platform")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={platFormSearch || null}
                            onChangeSelect={(e: any) => setPlatFormSearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("OS")} isShow={true}>
                          <DropdownOptionImage
                            name="os"
                            dataList={LIST_OPTION_OS || []}
                            placeholder={`${t("OS")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={oSSearch || ""}
                            onChangeSelect={(e: any) => setOSSearch(e?.value)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={t("Store Connection")}
                          isShow={true}
                        >
                          <DropdownStatusNew
                            name="user-type"
                            dataList={LIST_OPTION_STORE_CONNECTION || []}
                            placeholder={`${t("Store Connection")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={storeConnectionSearch}
                            onChangeSelect={(e: any) =>
                              setStoreConnectionSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_STORE_CONNECTION}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={t("Job Posting Status")}
                          isShow={true}
                        >
                          <DropdownStatusNew
                            name="user-type"
                            dataList={LIST_OPTION_JOB_POSTING_STATUS || []}
                            placeholder={`${t("Job Posting Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={jobPostingStatusSearch}
                            onChangeSelect={(e: any) =>
                              setJobPostingStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_JOB_POSTING_STATUS}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("User Type")} isShow={true}>
                          <DropdownStatusNew
                            name="user-type"
                            dataList={LIST_OPTION_USER_TYPE || []}
                            placeholder={`${t("User Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={userTypeSearch}
                            onChangeSelect={(e: any) =>
                              setUserTypeSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_USER_TYPE}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Adult Verify")} isShow={true}>
                          <DropdownStatusNew
                            name="user-type"
                            dataList={LIST_OPTION_ADULT_VERIFY || []}
                            placeholder={`${t("Adult Verify")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={adultVerifySearch}
                            onChangeSelect={(e: any) =>
                              setAdultVerifySearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_ADULT_VERIFY}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Status")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={STATUS_ACTIVE_DISABLE_OPTION || []}
                            placeholder={`${t("Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch}
                            onChangeSelect={(e: any) =>
                              setStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_STATUS_ACTIVE_DISABLE}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={`${t("Agency Code, Name")}`}
                          isShow={!!agencySearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Agency Code, Name")}...`}
                            value={agencySearch}
                            onChange={(e) => setAgencySearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Channel")} isShow={true}>
                          <DropdownChannel
                            name="channel"
                            placeholder={`${t("Channel")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={channelSearch}
                            onChangeSelect={(e: any) => {
                              setChannelSearch(e?.value);
                            }}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Source Channel")} isShow={true}>
                          <DropdownStatusNew
                            name="source-channel"
                            dataList={LIST_OPTION_SOURCE_CHANNEL.filter((item: any) => item?.value !== ENUM_SOURCE_CHANNEL.CONSOLE) || []}
                            placeholder={`${t("Source Channel")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={sourceChannelSearch}
                            onChangeSelect={(e: any) =>
                              setSourceChannelSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_SOURCE_CHANNEL}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-4 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!registeredFrom || !!registeredTo}
                        >
                          <DatePickerCustom
                            startDate={registeredFrom || null}
                            endDate={registeredTo || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={9}
                        lg={9}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed sticky-table-user-recruiter-media"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={users?.items?.length ? users?.items : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={users?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(users?.pagination?.total) / Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sortBy: query.sortBy,
                        orderBy: query.orderBy,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isUserLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {itemToEdit && (
          <RecruiterDetail
            isOpen={!!itemToEdit}
            item={itemToEdit}
            onClose={onCloseClick}
            triggerRefresh={triggerRefresh}
            setLinkImage={setLinkImage}
          />
        )}

        {itemToDelete && (
          <ModalConfirm
            header={t("Delete User")}
            isOpen={itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            onConfirm={() => handleActionDelete(itemToDelete?._id)}
          />
        )}

        {itemConfirmAdultVerify && (
          <ModalConfirm
            header={t("Adult Verify")}
            isOpen={!!itemConfirmAdultVerify}
            isLoading={isConfirmAdultVerifyLoading}
            onClose={() => setItemConfirmAdultVerify(null)}
            onConfirm={() => handleUpdateAdultVerify(itemConfirmAdultVerify)}
            isShowIcon={false}
            title={t(`Are you sure you want to ${itemConfirmAdultVerify?.isAgeVerified === false ? "Verify Now" : "Reset"}?`)}
            content=""
            isShowButtonClose={false}
            textButtonConfirm={t("Button Submit")}
            classIconButtonConfirm={"ri-login-circle-line cursor-pointer"}
            classButtonConfirm="bg-primary text-white"
          />
        )}

        <ModalPreview
          type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreview
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        {itemNotification && (
          <ModalPerNotification
            isOpen={!!itemNotification}
            onClose={handleCloseNotification}
            userID={itemNotification}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default RecruiterVirtualList;
